import { Injectable } from "@angular/core";

@Injectable()
export class TemplateRenderService {
  template = " ";

  constructor() {}

  public renderTemplate(templateJson): string {
    this.template = `<kl-form-container [mode]="mode"
                                        [pageId]="tabId ? tabId : modalId"
                                        [alertMessage]="alertMessage"
                                        [alertShow]="alertShow"
                                        (onCloseAlert)="alertShow = false;"
                                        (onCommitSave)="DynamicForm.valid ? commitSave($event) : invalidInput()"
                                        (onSaveTemplate)="saveTemplate()">
  <form #DynamicForm="ngForm" novalidate><accordion>`;
    for (let i = 0; i < templateJson.length; i++) {
      this.template = this.template + templateJson[i].html;
      for (let j = 0; j < templateJson[i].content.length; j++) {
        this.template =
          this.template +
          (templateJson[i].content[j].html
            ? templateJson[i].content[j].html
            : "");
        if (templateJson[i].content[j].children) {
          for (let k = 0; k < templateJson[i].content[j].children.length; k++) {
            this.template =
              this.template +
              (templateJson[i].content[j].children[k].html
                ? templateJson[i].content[j].children[k].html
                : "") +
              (templateJson[i].content[j].children[k].closeTag
                ? templateJson[i].content[j].children[k].closeTag
                : "");
          }
        }
      }
    }
    return this.template;
  }
}
